// External Libraries
import React from "react";
import * as Icon from "react-feather";

// Services
import ClientService from "../../../services/ClientService";
import ConfigurationService from "../../../services/ConfigurationService";
import QboService from "../../../services/QboService";
import UserService from "../../../services/UserService";

// Common Components
import WComponent from "../../common/WComponent";
import ToolCard from "../../common/tool_card/ToolCard";

// Components
// import ReconciliationTool from "./ReconciliationTool/ReconciliationTool";
import PlaidConnectionModal from "./PlaidConnectionModal";

// Styling
import "./connections.css";

const CONNECTIONS = {
	plaidConnection: {
		type: "plaidConnection",
		title: "Connect Bank Account",
		description: "Creates a new link to send to a client and have them connect their bank account to Workflow.",
		Icon: Icon.Key
	},
	qboConnection: {
		type: "qboConnection",
		title: "QBO Connection",
		description: "Allows tools like HST Reconciliation to work",
		Icon: Icon.RefreshCcw
	}
};

class Connections extends WComponent {
	constructor(props) {
		super(props);

		this.state = {
			isQBOConnected: false,

			showPlaidConnectionModal: false,

			qboCompanies: [],
			selectedRealmId: "",
			isLoadingCompanies: false,
			isMappingClient: false,
			mapClientSuccess: false
		};
	}

	async componentDidMount() {
		let { clientId } = this.props;

		let { data } = await ClientService.getClient({ clientId });

		let isQBOConnected = data.client.qbo_company_id !== null;

		this.update({ isQBOConnected });

		await this.fetchQboCompanies();
	}

	async fetchQboCompanies() {
		let { clientId } = this.props;
		this.update({ isLoadingCompanies: true });
		try {
			const response = await QboService.getCompanies();
			const companies = response && response.data ? response.data.companies : [];
			const mapped = companies && companies.find(c => String(c.workflowClientId) === String(clientId));
			this.update({ qboCompanies: companies || [], selectedRealmId: mapped ? mapped.realmId : "" });
		} catch (error) {
			console.log(error);
		}
		this.update({ isLoadingCompanies: false });
	}

	onConnect = async type => {
		if (type === CONNECTIONS.qboConnection.type) {
			const user = UserService.getUserData();
			let tokenParam = "";
			if (user && user.authToken) {
				tokenParam = `?authToken=${encodeURIComponent(user.authToken)}`;
			}
			window.open(`${ConfigurationService.resolveApi().rest}/integration/qbo/auth${tokenParam}`, "_blank");
			return;
		}

		if (type === CONNECTIONS.plaidConnection.type) {
			await this.update({
				showPlaidConnectionModal: true
			});
			return;
		}
	};

	onPlaidConnectionModalClose = () => {
		this.update({
			showPlaidConnectionModal: false
		});
	};

	onCompanyChange = e => {
		this.update({ selectedRealmId: e.target.value, mapClientSuccess: false });
	};

	onMapClient = async () => {
		let { clientId } = this.props;
		let { selectedRealmId } = this.state;

		if (!selectedRealmId) return;

		this.update({ isMappingClient: true, mapClientSuccess: false });
		try {
			await QboService.mapClient({ workflowClientId: clientId, realmId: selectedRealmId });
			this.update({ mapClientSuccess: true });
		} catch (error) {
			console.log(error);
		}
		this.update({ isMappingClient: false });
	};

	renderConnectionOption(toolOption) {
		return <ToolCard toolProps={toolOption} disabled={false} onClick={this.onConnect} />;
	}

	renderQboMapping() {
		let { qboCompanies, selectedRealmId, isLoadingCompanies, isMappingClient, mapClientSuccess } = this.state;
		const user = UserService.getUserData();

		if (isLoadingCompanies) {
			return (
				<div className="qbo-mapping">
					<p className="qbo-mapping__loading">Loading QBO companies...</p>
				</div>
			);
		}

		if (!qboCompanies || qboCompanies.length === 0) {
			return (
				<div className="qbo-mapping">
					<p className="qbo-mapping__label">No QBO companies authorized yet.</p>
					<button
						className="qbo-mapping__authorize-btn"
						onClick={() => {
							let tokenParam = user && user.authToken ? `?authToken=${encodeURIComponent(user.authToken)}` : "";
							window.open(`${ConfigurationService.resolveApi().rest}/integration/qbo/auth${tokenParam}`, "_blank");
						}}
					>
						<Icon.Lock size={14} style={{ marginRight: 6 }} />
						Authorize QBO
					</button>
				</div>
			);
		}

		return (
			<div className="qbo-mapping">
				<p className="qbo-mapping__title">Map Client to QBO</p>
				<div className="qbo-mapping__row">
					<div className="qbo-mapping__field">
						<label className="qbo-mapping__label">Company</label>
						<select className="qbo-mapping__select" value={selectedRealmId} onChange={this.onCompanyChange}>
							<option value="">Select a company</option>
							{qboCompanies.map(c => (
								<option key={c.realmId} value={c.realmId}>
									{c.companyName}
								</option>
							))}
						</select>
					</div>

					<button
						className="qbo-mapping__map-btn"
						onClick={this.onMapClient}
						disabled={!selectedRealmId || isMappingClient}
					>
						{isMappingClient ? "Saving..." : "Map Client"}
					</button>
				</div>
				{mapClientSuccess && <p className="qbo-mapping__success">Client mapped successfully.</p>}
			</div>
		);
	}

	render() {
		let { clientId } = this.props;
		let { showPlaidConnectionModal } = this.state;

		const connectionsOptionArray = Object.values(CONNECTIONS);

		return (
			<>
				<div className="container">
					<div className="container__body">
						<div className="connections">
							{connectionsOptionArray.map(connectionOption => this.renderConnectionOption(connectionOption))}
							{this.renderQboMapping()}
						</div>
					</div>
				</div>
				<PlaidConnectionModal clientId={clientId} show={showPlaidConnectionModal} onClose={this.onPlaidConnectionModalClose} />
			</>
		);
	}
}

export default Connections;
